import { Fragment, useState} from 'react';
import { Col, Row, Breadcrumb, Tab, Nav, NavDropdown, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// import settings component
import CompanySettings from './company/CompanySettings';
import PlansSettings from './plans/PlansSettings';
import BillingSettings from './billing/BillingSettings';
import UsersSettings from './users/UsersSettings';

const AllSettings = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeTab, setActiveTab] = useState(() => {
		const tabFromUrl = searchParams.get('tab');
		return ['company', 'plans', 'billing', 'users'].includes(tabFromUrl) ? tabFromUrl : 'company';
	});

	const handleTabSelect = (key) => {
		setActiveTab(key);
		setSearchParams({ tab: key });
	};
	
	return (
		<Fragment>
			<Row>
				<Col>
					<Row>
						<Col lg={12} md={12} sm={12}>
							<div className="border-bottom pb-4 mb-4 d-md-flex align-items-center justify-content-between">
								<div className="mb-3 mb-md-0">
									<h1 className="mb-1 h2 font-weight-bold">{t('Settings')}</h1>
									<Breadcrumb>
										<Breadcrumb.Item href="#">{t('Dashboard')}</Breadcrumb.Item>
										<Breadcrumb.Item active>{t('Settings')}</Breadcrumb.Item>
									</Breadcrumb>
								</div>
							</div>
						</Col>
					</Row>
					<Tab.Container id="left-tabs-settings" activeKey={activeTab} onSelect={handleTabSelect}>
						<Row>
							<Col lg={2} md={12}>
								<Nav variant="pills" className="flex-column">
									<Nav.Item>
										<Nav.Link eventKey="company"><i className="fe fe-briefcase me-2"></i> {t('Company')}</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="plans"><i className="fe fe-package me-2"></i> {t('Plans and Subscriptions')}</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="billing"><i className="fe fe-credit-card me-2"></i> {t('Billing')}</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="users"><i className="fe fe-user me-2"></i> {t('User Administration')}</Nav.Link>
									</Nav.Item>
								</Nav>
							</Col>
							<Col lg={10} md={12} className="mt-3 mt-lg-0">
								<Tab.Content>
									<Tab.Pane eventKey="company">
										<CompanySettings activeKey={activeTab} />
									</Tab.Pane>
									<Tab.Pane eventKey="plans">
										<PlansSettings activeKey={activeTab} />
									</Tab.Pane>
									<Tab.Pane eventKey="billing">
										<BillingSettings activeKey={activeTab} />
									</Tab.Pane>
									<Tab.Pane eventKey="users">
										<UsersSettings activeKey={activeTab} />
									</Tab.Pane>
								</Tab.Content>
							</Col>
						</Row>
					</Tab.Container>
				</Col>
			</Row>
		</Fragment>
	);

};

export default AllSettings;